import { JobContact } from '@/api/Job';
import { AppModule } from '@/store/modules/app';

// Street, postcode and town of the company profile, else of the ad, else the job location
export const jobAddress = (info: Record<string, any>, contact: JobContact | null, fallback: string): string => {
  const profile = [info.address, [info.plz, info.ort].filter(Boolean).join(' ')].filter(Boolean).join(', ');
  if (profile) return profile;
  const street = [contact?.street, contact?.street_no].filter(Boolean).join(' ');
  const town = [contact?.plz, contact?.city].filter(Boolean).join(' ');
  return [street, town].filter(Boolean).join(', ') || fallback;
};

// Google Maps of the address, embeddable in an iframe; zoom 12 shows the town around the address
export const mapEmbedUrl = (address: string): string => `https://maps.google.com/maps?q=${encodeURIComponent(address)}&z=12&hl=${AppModule.language || 'de'}&output=embed`;
